import { postAdmin } from "../axios/api/AdminBaseUrl"

export const media ={

    mediaadd:{
      key: "mediaadd",
      call:(payload)=>{ return postAdmin(`/admin/presigned_url_of_aws`,payload);
    }
    },
}